import React from 'react';
import { motion } from 'framer-motion';

interface CompletionScreenProps {
  score: number;
}

export const CompletionScreen: React.FC<CompletionScreenProps> = ({ score }) => {
  const encouragementMessage = score < 10
    ? "Great effort! Keep practicing and you'll be a math wizard in no time!"
    : "Fantastic job! You're a math superstar!";

  return (
    <motion.div 
      className="completion-screen"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <h2 className="completion-title">
        Congratulations! <span role="img" aria-label="party popper">🎉</span>
      </h2>
      <p className="encouragement-message">{encouragementMessage}</p>
      <div className="score-display">
        <span className="score-number">{score}</span>
        <span className="score-divider">/</span>
        <span className="score-total">10</span>
      </div>
      <div className="animal-character">
        <motion.span
          role="img"
          aria-label="lion"
          initial={{ rotate: 0 }}
          animate={{ rotate: [0, -10, 10, -10, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          🦁
        </motion.span>
      </div>
      <p className="final-message">You've completed your math adventure!</p>
    </motion.div>
  );
};
